import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { urlParams, decode_utf8, getPathName } from '../../../../common/utils/utilsFunc';
import SubscriptionsContextProvider, { ACTIONS, SubscriptionsContext } from '../../context/SubscriptionsContextProvider';
import "../../styles/index.scss"
import Loading from "../../../../common/components/Loading";
import classNames from 'classnames'

function AltaSubscriptionsConfirmation({ props }) {
    const [state, dispatch] = React.useContext(SubscriptionsContext)
    const [responseMsg, setResponseMsg] = React.useState("")
    const [success, setSuccess] = React.useState("")
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        let id = urlParams.get('id')
        let json = {
            "id": id,
            "empresa": props.codigo_empresa,
            "url": props.url_ws_empresa,
            // eslint-disable-next-line no-undef
            "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        }
        dispatch({
            type: getPathName() === 'confirmacion-alta-suscripcion' ? ACTIONS.SET_JSON_CONFIRMATION_ALTA_SUBSCRIPTION : ACTIONS.SET_JSON_CONFIRMATION_MODIFICATION_SUBSCRIPTION,
            payload: json
        })
        setLoading(true)
    }, [])

    React.useEffect(() => {
        if (state.responseConfirmationAltaSubscription) {
            setLoading(false)
            if (state.responseConfirmationAltaSubscription.code === 0) {
                setResponseMsg(state.responseConfirmationAltaSubscription.message)
                setSuccess(true)
            } else {
                setResponseMsg(state.responseConfirmationAltaSubscription.message?state.responseConfirmationAltaSubscription.message:decode_utf8(props.text_fetch_error))
                setSuccess(false)
            }
        }
    }, [state.responseConfirmationAltaSubscription])

    React.useEffect(() => {
        if (state.responseConfirmationModificationSubscription) {
            setLoading(false)
            if (state.responseConfirmationModificationSubscription?.code || state.responseConfirmationModificationSubscription?.code === 0) {
                if (state.responseConfirmationModificationSubscription.code === 0) {
                    setResponseMsg(state.responseConfirmationModificationSubscription.message)
                    setSuccess(true)
                } else {
                    setResponseMsg(state.responseConfirmationModificationSubscription.message)
                    setSuccess(false)
                }
            } else {
                setSuccess(false)
                setResponseMsg(decode_utf8(props.text_fetch_error))
            }
        }

    }, [state.responseConfirmationModificationSubscription])

    function handleButtonClick() {
        window.location.href = '/servicios-en-linea'
    }
    return (
        <div id="cge-altaSubscriptionConfirmation">
            <CGE.Panel title={getPathName() === 'confirmacion-alta-suscripcion' ? decode_utf8(props.title_confirmation_alta_subscription) : decode_utf8(props.title_confirmation_modificacion_subscription)}>
                <CGE.PanelContainer
                    className="p-4"
                    alingItensCenter={true}
                    size="sm"
                >
                    <div className={classNames(
                        "cge-altaSubscriptionConfirmation__icon",
                        {
                            "cge-altaSubscriptionConfirmation__icon--success": success
                        })}>
                        {success ?
                            <p><CGE.Icon name="check" /></p> : <p><CGE.Icon name="attention" /></p>}
                    </div>
                    <CGE.Heading
                        className="font-weight-normal text-justify"
                        size="4"
                        text={responseMsg}
                    />
                    <CGE.Spacing type="ct" />
                    <div className="d-flex justify-content-center" >
                        <CGE.Button
                            onClick={() => handleButtonClick()}
                            label="Volver"
                        />
                    </div>
                </CGE.PanelContainer>
                {loading && <Loading />}
            </CGE.Panel>
        </div>
    )
}

const AltaSubscriptionsWithProvider = ({
    props

}) => (
    <SubscriptionsContextProvider>
        <AltaSubscriptionsConfirmation
            props={props}
        />
    </SubscriptionsContextProvider>
);

export default AltaSubscriptionsWithProvider;